import Image from "next/image";

import { PreviewCanvasScale } from "./shared/preview-canvas-scale";
import { InsetProgressBar } from "./shared/progress-segment";
import type { ProgressBarLayer } from "./shared/progress-segment";

const BREAK_EVEN_MARKER =
  "/assets-next/tools/previews/svg/break-even-marker.svg";

const INTER_TABULAR = {
  fontFeatureSettings: '"ss03" 1, "ss01" 1, "zero" 1, "ss02" 1',
} as const;

/** 14px track — Figma 11752:77688. */
const TRACK_H = 14;
const CAP_H = 14;
const FULL_H = 14.176;
const CAP_INSET = { insetLeft: 0.31, insetTop: 0.12, height: CAP_H } as const;
const FULL_INSET = { insetLeft: 0, insetTop: 0, height: FULL_H } as const;

/** Figma 11752:77688 — break-even marker at ~3.3% of 375px track. */
const BREAK_EVEN_LAYERS: ProgressBarLayer[] = [
  { width: 375, fill: "#FFFFFF", ...FULL_INSET },
  { width: 156, fill: "#F9F9F8", ...CAP_INSET },
  { width: 300, fill: "#FFFFFF", ...FULL_INSET },
  { width: 240, fill: "#F9F9F8", ...CAP_INSET },
  { width: 114.18, fill: "#E5E6E6", ...CAP_INSET },
  { width: 17.773, fill: "#001EFF", ...CAP_INSET },
];

/**
 * Financing break-even card inset (Figma 11115:59211 desktop, 11128:40590 mobile).
 * Progress-bar style preview — not the live tool runway chart.
 */
export function FinancingBreakEvenPreview() {
  return (
    <PreviewCanvasScale testId="financing-break-even-canvas">
      <p
        className="text-grey-950 absolute top-[29px] left-[29px] text-[12px] leading-[1.4] whitespace-nowrap"
        style={INTER_TABULAR}
      >
        Break-even sell-through
      </p>

      <div className="border-grey-100 absolute top-[59px] left-[23px] h-[164px] w-[441px] overflow-hidden rounded-[10px] border bg-white">
        <div className="absolute top-[14.88px] left-[14.69px] w-[379.172px]">
          <InsetProgressBar trackHeight={TRACK_H} layers={BREAK_EVEN_LAYERS} />
        </div>

        {/* Figma 11752:77708 — chevron at right edge of blue break-even cap */}
        <div
          aria-hidden
          className="pointer-events-none absolute top-[28.38px] left-[34.63px] h-[7.224px] w-[6.256px]"
        >
          <div className="absolute inset-[-22.67%_-23.98%_-22.67%_-31.97%]">
            <Image
              src={BREAK_EVEN_MARKER}
              alt=""
              width={10}
              height={11}
              className="block size-full max-w-none"
            />
          </div>
        </div>

        <p
          className="text-grey-500 absolute top-[35.6px] left-[37.75px] text-[10px] leading-[1.4] whitespace-nowrap"
          style={INTER_TABULAR}
        >
          Break even
        </p>

        <div
          className="absolute top-[57.5px] left-[14.69px] flex flex-col gap-1"
          style={INTER_TABULAR}
        >
          <p className="text-grey-950 text-[36px] leading-none font-medium tracking-[-0.02em]">
            3.3%
          </p>
          <p className="text-grey-500 w-[413px] text-[10px] leading-[1.4]">
            All of the extra stock you need to sell
          </p>
        </div>
      </div>
    </PreviewCanvasScale>
  );
}
